// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__Dls1W","info":"Note_info__1En5R","note":"Note_note__beYSp","actions":"Note_actions__2Blqw"};